import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
};

// {@rule opportunity-attacks, Внеочередную атаку}
export const RulePlugin: React.FC<Props> = ({args}) => {
	const [id, ...rest] = args;
	const title = rest.join(', ') || id;
	return (
		<Link route="rule" params={{id}} title={title} className={linkClass('rule')}>
			{title}
		</Link>
	);
};
